"use strict";

var _regeneratorRuntime = require("/codebuild/output/src372278538/src/github.com/wobicom/wobi-web-auto/node_modules/babel-preset-react-app/node_modules/@babel/runtime/regenerator");
var _asyncToGenerator = require("/codebuild/output/src372278538/src/github.com/wobicom/wobi-web-auto/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/asyncToGenerator");
var _classCallCheck = require("/codebuild/output/src372278538/src/github.com/wobicom/wobi-web-auto/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");
var _createClass = require("/codebuild/output/src372278538/src/github.com/wobicom/wobi-web-auto/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/createClass");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getImageByAgent = exports.findSelectedOption = exports.agentDeveloperUtils = exports.AgentDeveloperUtils = void 0;
var _agentsData = _interopRequireDefault(require("../../config/agentsData.json"));
var _storageHelpers = require("./storageHelpers");
var _urlHelper = require("./urlHelper");
function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}
/* eslint-disable import/no-dynamic-require */
/* eslint-disable global-require */
/* eslint-disable consistent-return */
/* eslint-disable import/exports-last */
/* eslint-disable import/no-commonjs */

var findSelectedOption = function findSelectedOption(value, suggestions) {
  if (value === null) {
    return;
  }
  return suggestions.find(function (element) {
    return element.value === value;
  });
};

// eslint-disable-next-line fp/no-class
exports.findSelectedOption = findSelectedOption;
var AgentDeveloperUtils = /*#__PURE__*/function () {
  function AgentDeveloperUtils() {
    _classCallCheck(this, AgentDeveloperUtils);
    this.agentsDeveloperData = _agentsData.default;
    this.agentData = _agentsData.default.Wobi;
    this.serviceType = '';
    this.websiteConfig = {};
    this.assetsPath = '/assets';
    this.isWebEnv = Boolean(global.document);
    this.memoDom = {};
    this.isWebSiteEnabled = true;
  }
  _createClass(AgentDeveloperUtils, [{
    key: "getAssetsPath",
    get: function get() {
      return "assets/img/agents/".concat(this.getAgentDeveloperName);
    }
  }, {
    key: "getAgencyServicePhoneNumber",
    get: function get() {
      return this.websiteConfig.agencyServicePhoneNumber;
    }
  }, {
    key: "getAgentImagePath",
    value: function getAgentImagePath(imageName) {
      return "".concat(this.getAssetsPath, "/").concat(imageName);
    }
  }, {
    key: "getAgentDisplayName",
    get: function get() {
      var _this$agentData;
      return (_this$agentData = this.agentData) === null || _this$agentData === void 0 ? void 0 : _this$agentData.Display_Name__c;
    }
  }, {
    key: "getWhatsappNumber",
    get: function get() {
      return this.websiteConfig.whatsAppNumber;
    }
  }, {
    key: "serviceWebsiteUrl",
    get: function get() {
      return this.websiteConfig.links.website;
    }
  }, {
    key: "getAgentDeveloperName",
    get: function get() {
      return agentDeveloperUtils.agentData.Agent_Developer_Name_c;
    }
  }, {
    key: "getAgentLinks",
    get: function get() {
      var _this$agentData2;
      return (_this$agentData2 = this.agentData) === null || _this$agentData2 === void 0 ? void 0 : _this$agentData2.links;
    }
  }, {
    key: "getAgentEmail",
    get: function get() {
      return this.websiteConfig.email;
    }
  }, {
    key: "getSupportedServices",
    get: function get() {
      return this.agentData.supportedServices;
    }
  }, {
    key: "getIsShowPoweredByWobi",
    get: function get() {
      return this.websiteConfig.isShowPoweredByWobi;
    }
  }, {
    key: "getFooterDisclamerText",
    get: function get() {
      return this.websiteConfig.footerDisclamerText;
    }
  }, {
    key: "getCarHandlingFee",
    value: function getCarHandlingFee() {
      return this.websiteConfig.carHandlingFee ? this.websiteConfig.carHandlingFee : 0;
    }
  }, {
    key: "isUsingCarHandlingFee",
    value: function isUsingCarHandlingFee(isSimulator) {
      // if (!localStorage.getItem('isUsingHendlingFee')) {
      //   return false;
      // }
      // eslint-disable-next-line no-unused-vars
      var lastName = '';
      if (isSimulator) {
        var simulator_offers_fields = sessionStorage.getItem('simulator_offers_fields');
        if (simulator_offers_fields) {
          simulator_offers_fields = JSON.parse(simulator_offers_fields);

          // lastName = simulator_offers_fields?.lastName;
        }
      } else {
        var offers_fields = sessionStorage.getItem('offers_fields');
        if (offers_fields) {
          offers_fields = JSON.parse(offers_fields);

          // lastName = offers_fields?.lastname;
        }
      }

      // if (lastName !== 'דמיטיפול') {
      //   return false;
      // }
      if (this.websiteConfig.carHandlingFee === 0 || !this.websiteConfig.carHandlingFee) {
        return false;
      }
      return true;
    }

    // new generic handling fee functions
  }, {
    key: "getHomeHandlingFee",
    value: function getHomeHandlingFee() {
      return this.websiteConfig.homeHandlingFee ? this.websiteConfig.homeHandlingFee : 0;
    }
  }, {
    key: "isUsingHomeHandlingFee",
    value: function isUsingHomeHandlingFee() {
      if (this.websiteConfig.homeHandlingFee === 0 || !this.websiteConfig.homeHandlingFee) {
        return false;
      }
      return true;
    }
  }, {
    key: "isOtpFirstInUrl",
    value: function isOtpFirstInUrl(location) {
      return (0, _urlHelper.isUrlKeyHasValue)(location, 'otp', 'first');
    }
  }, {
    key: "isOtpFirstInOffersFields",
    value: function isOtpFirstInOffersFields() {
      var otpValue = (0, _storageHelpers.getOffersFields)('otp');
      if (otpValue === 'first') {
        return true;
      }
      return false;
    }
  }, {
    key: "getSerivceWebsiteUrl",
    value: function getSerivceWebsiteUrl() {
      var serviceType = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
      if (!this.agentData.websites[serviceType === null || serviceType === void 0 ? void 0 : serviceType.toLowerCase()]) {
        console.error('Service type not found, please check the service type' + serviceType);
        return;
      }
      return this.agentData.websites[serviceType === null || serviceType === void 0 ? void 0 : serviceType.toLowerCase()].links.website;
    }
  }, {
    key: "getOffersTeaser",
    get: function get() {
      return this.agentData.offersTeaser;
    }
  }, {
    key: "getWebsiteBaseUrl",
    get: function get() {
      var serviceUrl = this.websiteConfig.baseUrls.find(function (url) {
        return window.location.href.includes(url);
      });
      return serviceUrl || this.websiteConfig.baseUrls[0];
    }
  }, {
    key: "getAgentLogos",
    value: function getAgentLogos() {
      return this.agentData.logos;
    }
  }, {
    key: "replaceFavicon",
    value: function replaceFavicon() {
      var faviconLink = "agents/".concat(this.getAgentDeveloperName, "/favicon.ico");
      var link = document.createElement('link');
      link.rel = 'icon';
      link.href = faviconLink;
      document.head.append(link);
    }
  }, {
    key: "replaceWebsiteTitle",
    value: function replaceWebsiteTitle() {
      var title = document.querySelector('title');
      title.innerHTML = this.agentData.websites[this.serviceType].windowTitle;
    }
  }, {
    key: "replaceWebsiteDescription",
    value: function replaceWebsiteDescription() {
      var description = document.querySelector('meta[name="description"]');
      if (description) {
        description.content = this.agentData.websites[this.serviceType].description;
      }
    }
  }, {
    key: "replaceWobiWithAgentName",
    value: function replaceWobiWithAgentName() {
      var _this = this;
      if (this.getAgentDeveloperName === 'Wobi') {
        return;
      }
      var elements = document.querySelectorAll('h1, h2, h3, h4, h5, h6, p, span, a');
      elements.forEach(function (element) {
        if (_this.memoDom[element.innerHTML] || element.classList.contains('IGNORE_NAME_REPLACE')) {
          return;
        }
        if (element.innerHTML.includes('Wobi סוכנות לביטוח') && _this.getAgentDisplayName.includes('סוכנות לביטוח')) {
          element.innerHTML = element.innerHTML.replace('Wobi סוכנות לביטוח', _this.getAgentDisplayName);
        } else if (element.innerHTML.includes('Wobi')) {
          element.innerHTML = element.innerHTML.replace('Wobi', _this.getAgentDisplayName);
        }
        _this.memoDom[element.innerHTML] = true;
      });
    }
  }, {
    key: "replaceManifastName",
    value: function () {
      var _replaceManifastName = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
        var res, data, logos, displayName, updatedManifest, blob, manifestUrl;
        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.prev = 0;
                _context.next = 3;
                return fetch('/manifest.json');
              case 3:
                res = _context.sent;
                _context.next = 6;
                return res.json();
              case 6:
                data = _context.sent;
                logos = this.getAgentLogos();
                if (!(!logos || !logos.logo192 || !logos.logo512)) {
                  _context.next = 10;
                  break;
                }
                throw new Error('Logos are not defined correctly');
              case 10:
                displayName = agentDeveloperUtils.getAgentDisplayName;
                if (!(typeof displayName !== 'string')) {
                  _context.next = 13;
                  break;
                }
                throw new TypeError('Display name is not a string');
              case 13:
                data.name = displayName;
                data.short_name = displayName;
                if (!(!Array.isArray(data.icons) || data.icons.length < 3)) {
                  _context.next = 17;
                  break;
                }
                throw new Error('Icons array is not defined correctly');
              case 17:
                data.icons[0] = "".concat(this.getAgentDeveloperName, "/favicon.ico");
                data.icons[1] = "".concat(this.getAgentDeveloperName, "/").concat(logos.logo192.src);
                data.icons[2] = "".concat(this.getAgentDeveloperName, "/").concat(logos.logo512.src);
                data.start_url = '.';
                updatedManifest = JSON.stringify(data);
                blob = new Blob([updatedManifest], {
                  type: 'application/json'
                });
                manifestUrl = URL.createObjectURL(blob);
                document.querySelector('link[rel="manifest"]').href = manifestUrl;
                _context.next = 30;
                break;
              case 27:
                _context.prev = 27;
                _context.t0 = _context["catch"](0);
                console.error('error updating agent : ', _context.t0);
              case 30:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, this, [[0, 27]]);
      }));
      function replaceManifastName() {
        return _replaceManifastName.apply(this, arguments);
      }
      return replaceManifastName;
    }()
  }, {
    key: "setAgentData",
    value: function setAgentData(agentDeveloperName, serviceType) {
      this.agentData = this.agentsDeveloperData[agentDeveloperName] || this.agentsDeveloperData.Wobi;
      this.serviceType = serviceType;
      this.websiteConfig = this.agentData.websites[serviceType];
    }
  }, {
    key: "getOffersUpTo",
    value: function getOffersUpTo() {
      return this.agentData.websites.travel.offersUpTo;
    }
  }, {
    key: "getAgentDeveloperData",
    value: function getAgentDeveloperData(file) {
      this.agentsDeveloperData = _agentsData.default;
      if (file && file !== null && file !== void 0 && file.Wobi) {
        this.agentsDeveloperData = file;
      }
      if (!this.isWebEnv) {
        return;
      }
      var hostname = window.location.hostname;
      var typeOfAgent = localStorage.getItem('typeOfAgent');
      var isAuto = hostname.includes('auto');
      var isTravel = hostname.includes('travel');
      var isLocalHost = hostname.includes('localhost');
      var serviceType = 'auto';
      if (isAuto || isLocalHost) {
        serviceType = 'auto';
      } else if (isTravel) {
        serviceType = 'travel';
      } else {
        serviceType = 'home';
      }

      // check there is typeOfAgent in local storage for testing

      if (window.location.href.includes('testP') && isLocalHost) {
        this.agentData = this.agentsDeveloperData.Post_IL;
      } else if (window.location.href.includes('testW') && isLocalHost) {
        this.agentData = this.agentsDeveloperData.Wobi;
      } else if (typeOfAgent) {
        this.agentData = this.agentsDeveloperData[typeOfAgent];
      } else {
        // eslint-disable-next-line max-len
        var agentData = Object.values(this.agentsDeveloperData).find(function (agent) {
          return agent.websites[serviceType].baseUrls.find(function (url) {
            return url.includes(hostname);
          });
        });
        this.agentData = agentData;
      }
      if (!this.agentData) {
        this.agentData = (file === null || file === void 0 ? void 0 : file.Wobi) || _agentsData.default.Wobi;
        this.isWebSiteEnabled = false;
      }
      this.serviceType = serviceType;
      this.websiteConfig = this.agentData.websites[serviceType];

      // find and replace the favicon and title of the website
      this.replaceFavicon();
      this.replaceWebsiteTitle();
      this.replaceWebsiteDescription();
    }
  }, {
    key: "getGtmId",
    value: function getGtmId() {
      return this.websiteConfig.TAG_MANAGER_ID;
    }
  }, {
    key: "getAdditionalTagManegerIds",
    value: function getAdditionalTagManegerIds() {
      return this.websiteConfig.additionalTagManegerIds;
    }
  }, {
    key: "getPrimaryColor",
    value: function getPrimaryColor(number) {
      var _this$agentData3;
      return (_this$agentData3 = this.agentData) === null || _this$agentData3 === void 0 ? void 0 : _this$agentData3.colors.primaryColor[number];
    }
  }, {
    key: "getSecondaryColor",
    value: function getSecondaryColor(number) {
      var _this$agentData4;
      return (_this$agentData4 = this.agentData) === null || _this$agentData4 === void 0 ? void 0 : _this$agentData4.colors.secondaryColor[number];
    }
  }, {
    key: "getConvertedColor",
    value: function getConvertedColor(color) {
      var colorType = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'hash';
      var _this$agentData5;
      var colorKey = color;
      if (colorType === 'hash' && color[0] !== '#') {
        colorKey = "#".concat(color);
      }
      var convertedColor = (_this$agentData5 = this.agentData) === null || _this$agentData5 === void 0 ? void 0 : _this$agentData5.colors.convertColors[colorKey];
      if (convertedColor) {
        return convertedColor;
      }
      return color;
    }
  }, {
    key: "getIsWebSiteEnabled",
    get: function get() {
      return this.isWebSiteEnabled;
    }
  }, {
    key: "getOtpMethods",
    get: function get() {
      var _this$agentData6, _this$agentData7;
      return (_this$agentData6 = this.agentData) !== null && _this$agentData6 !== void 0 && _this$agentData6.otpMethods ? (_this$agentData7 = this.agentData) === null || _this$agentData7 === void 0 ? void 0 : _this$agentData7.otpMethods : ['SMS'];
    }
  }]);
  return AgentDeveloperUtils;
}();
exports.AgentDeveloperUtils = AgentDeveloperUtils;
var agentDeveloperUtils = exports.agentDeveloperUtils = new AgentDeveloperUtils();
agentDeveloperUtils.getAgentDeveloperData();
var getImageByAgent = function getImageByAgent(imageName, config) {
  // eslint-disable-next-line global-require, import/no-dynamic-require
  var image;
  if (config && config[agentDeveloperUtils.getAgentDeveloperName]) {
    image = require('../../' + agentDeveloperUtils.getAgentImagePath(config[agentDeveloperUtils.getAgentDeveloperName]));
  } else {
    image = require('../../' + agentDeveloperUtils.getAgentImagePath(imageName));
  }
  return image;
};
exports.getImageByAgent = getImageByAgent;